import type { ReactNode } from 'react'

interface ProseSectionProps {
  readonly title: string
  readonly children: ReactNode
}

/**
 * A titled content block (H2 + body) for marketing pages. Body paragraphs are
 * passed as children so callers can compose multiple <p> / lists with the
 * Tailwind typography (`prose`) styling applied here.
 */
export function ProseSection({ title, children }: ProseSectionProps) {
  return (
    <section className="mx-auto max-w-3xl px-6 py-10">
      <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{title}</h2>
      <div className="prose prose-neutral mt-5 max-w-none dark:prose-invert prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground prose-a:text-primary">
        {children}
      </div>
    </section>
  )
}

interface ProseParagraphsProps {
  readonly paragraphs: readonly string[]
}

/** Renders an array of i18n strings as <p> blocks inside a ProseSection. */
export function ProseParagraphs({ paragraphs }: ProseParagraphsProps) {
  return (
    <>
      {paragraphs.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
    </>
  )
}
